export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/a3bc00d3bc648ac31b0828968790f397.svg";